import format from 'date-fns/format';
import moment from 'moment';

const oneHourInMilliSeconds = 60 * 60 * 1000;
const oneDayInMilliSeconds = 24 * 60 * 60 * 1000;

export const formatDisplayDate = (startDate, endDate) => {
  const dateFormat = 'D MMM YYYY';
  let formattedDates = '';
  if (startDate && endDate) {
    formattedDates = `${format(startDate, dateFormat)
    } - ${format(endDate, dateFormat)}`;
  }
  return formattedDates;
};

export const formatDate = (date) => {
  const dateFormat = 'YYYY-MM-DD';
  let formattedDate = '';
  if (date) {
    formattedDate = format(date, dateFormat);
  }
  return formattedDate;
};

export const formatDisplaySingleDate = (date) => {
  const dateFormat = 'D MMM YYYY';
  let formattedDate = '';
  if (date) {
    formattedDate = format(date, dateFormat);
  }
  return formattedDate;
};

export const formatDatesDummy = (startDate, endDate) => {
  const dateFormat = 'D MMM YY';
  let formattedDates = '';
  if (startDate && endDate) {
    formattedDates = `${format(startDate, dateFormat)
    } - ${format(endDate, dateFormat)}`;
  }
  return formattedDates;
};

export const formatCommentDate = (date) => {
  const dateFormat = 'MMM DD | hh:mm A';
  let formattedDate = '';
  if (date) {
    formattedDate = format(date, dateFormat);
  }
  return formattedDate;
};

export const formatDetailedCommentDate = (date) => {
  const dateFormat = 'DD MMM YYYY | hh:mm A';
  let formattedDate = '';
  if (date) {
    formattedDate = format(date, dateFormat);
  }
  return formattedDate;
};

export const getDateDiff = (date1, date2) => {
  const value = moment(date1).startOf('day').diff(moment(date2).startOf('day'), 'days');
  return value;
};

export const formatLastKnownTime = (date) => {
  const dateFormat = 'DD-MM-YYYY hh:mm A';
  let formattedDate = '';
  if (date && moment(date).isValid()) {
    formattedDate = format(date, dateFormat);
  }
  return formattedDate;
};

export const formatEtaTime = (date) => {
  const dateFormat = 'MMM DD hh:mm A';
  let formattedDate = '';
  if (date) {
    formattedDate = format(date, dateFormat);
  }
  return formattedDate;
};

export const formatDetailedTime = (date) => {
  const dateFormat = 'DD MMM YYYY - hh:mm A';
  let formattedDate = '';
  if (!date || !moment(date).isValid()) {
    formattedDate = date;
  } else if (date) {
    formattedDate = format(date, dateFormat);
  }
  return formattedDate;
};

export const formatTime = (date) => {
  const dateFormat = 'hh:mm A';
  let formattedDate = '';
  if (!date || !moment(date).isValid()) {
    formattedDate = date;
  } else if (date) {
    formattedDate = format(date, dateFormat);
  }
  return formattedDate;
};

export const getDateDiffInDaysMins = (date1, date2) => {
  if (date1 && date2) {
    const diff = moment(date1).diff(moment(date2), 'minutes');
    const prefix = diff < 0 ? '-' : '+';
    const absDiff = Math.abs(diff);
    const days = Math.floor(absDiff / (24 * 60));
    const hours = Math.floor((absDiff % (24 * 60)) / 60);
    const minutes = absDiff % 60;
    return { diff, formatted: `${prefix}${days}d ${hours} h ${minutes} min` };
  }
  return '';
};

export const extractMins = (milliseconds, hours) => {
  const min = milliseconds - (hours * oneHourInMilliSeconds);
  return ((min) / 1000) / 60;
};

export const extractHours = milliseconds => Math.floor(((milliseconds) / (oneHourInMilliSeconds)));

const convertIntoMilliSeconds = (mins, hours, days = 0) => (((((days * 24) + hours) * 60) + mins) * 60) * 1000;

const extractDays = milliseconds => Math.floor(((milliseconds) / oneDayInMilliSeconds));

const getDaysMinAndHoursFromMilliSecond = (millSecond) => {
  const hours = extractHours(millSecond);
  const minutes = extractMins(millSecond, hours);
  const days = extractDays(extractDays);
  return { hours, minutes, days };
};

function updateVehicleReqDate(arrivalCutOffMillSecond, vehicleRequirementDate, currentDate) {
  const { hours, minutes } = getDaysMinAndHoursFromMilliSecond(arrivalCutOffMillSecond);
  vehicleRequirementDate = moment(currentDate)
    .add(1, 'days')
    .hour(hours)
    .minute(minutes)
    .format();
  return vehicleRequirementDate;
}

export const getVehicleRequirementDate = (actualDate = new Date(), cutOffTimeMilliSecond,
  arrivalCutOffMillSecond) => {
  const currentDate = new Date();
  const currentHour = currentDate.getHours();
  const currentMin = currentDate.getMinutes();
  let vehicleRequirementDate = actualDate;
  if (moment(actualDate).isBefore(currentDate, 'day')) {
    vehicleRequirementDate = updateVehicleReqDate(arrivalCutOffMillSecond, vehicleRequirementDate,
      currentDate);
  } else if (moment(actualDate).isSame(currentDate, 'day')) {
    const hourAndMinuteInMillSecond = convertIntoMilliSeconds(currentMin, currentHour);
    if (hourAndMinuteInMillSecond > cutOffTimeMilliSecond) {
      vehicleRequirementDate = updateVehicleReqDate(arrivalCutOffMillSecond, vehicleRequirementDate,
        currentDate);
    }
  }
  return vehicleRequirementDate;
};
